<template ref="costumerSelect">
  <div class="row" id='costumerSelectToHide'>
    <div class="col-12">
      <label for="inputCostumersList">Cliente</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-search fa-fw"></i>
          </span>
        </div>
        <input
          type="hidden"
          autocomplete="off"
          :required="required"
          id="costumerId"
          name="costumer_id"
        />
        <input
          type="text"
          autocomplete="off"
          class="form-control autoComplete"
          id="inputCostumersList"
          name="costumer_name"
          ref="costumers"
          placeholder="Digite para buscar o cliente"
          :required="required"
          :readonly="readonly"
          :disabled="disabled"
		  @input="search"
        />
      </div>
      <div
        v-if="found"
        id="selectCostumers"
        style="background-color: #ffffff; border-radius: 3px; position: absolute; height: auto; width: 92%; z-index: 9999; box-shadow: 0px 3px 3px #ccc;"
      >
        <div class="list-group">
          <!-- list of founded costumers -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EventBus = new Vue;
export default {
  props: {
    required: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      found: [],
      url: window.location.pathname
    };
  },
  methods: {
    generatePhonesArray(data){
      let phones = new Array();
      let count = 0;
      while(count <= 3){
        data['telefone' + count] ? phones.push(data['telefone' + count]) : null;
        count++;
      }

      data['telefone'] ? phones.push(data['telefone']) : null;
      data['telefone_celular'] ? phones.push(data['telefone_celular']) : null;
      data['telefonedebusca'] ? phones.push(data['telefonedebusca']) : null;

      return phones;
	},

	async search(event){
	var self = this;
      let form = event.target.form;
      let name = event.target.value;
      await axios
        .get(self.url + "/searchClients", { params: { search: name } })
        .then(response => {
          const costumers = response.data;
          self.found = [];
          if (name.length > 0) {
            $.each(costumers, function(index, item) {
              if (
                item.first.toLowerCase().includes(name.toLowerCase()) ||
                item.cpf.includes(name) ||
                item.telefonedebusca.includes(name) ||
                item.telefone_celular.includes(name) ||
                item.telefone.includes(name) ||
                item.rg.toLowerCase().includes(name.toLowerCase())
              ) {
                item['phones'] = self.generatePhonesArray(item);
                self.found.push(item);
              }
            });

            $("#selectCostumers div.list-group button").remove();
            $.each(self.found, function(index, item) {
              var listItem = `<button type="button" data-data='${JSON.stringify(item)}' class="list-group-item list-group-item-action costumerListItem">${item.first}</button>`;
              $("#selectCostumers div.list-group").append(listItem);
            });
          } else {
            $("#selectCostumers div.list-group button").remove();
          }

          $(document).unbind("click").on("click", function(event) {
            if (
              $(event.target).hasClass("costumerListItem") ||
              event.target.id == "inputCostumersList"
            ) {
              if(modalWas){
                modalWas = false;
                return;
              }
              var elem = $(event.target);
              var data = elem.data("data");
              if(data){
                $("#inputCostumersList").val(data.first).data('data', data);
                $("#costumerId").val(data.id);
                
                data.cpf_cnpj = data.cpf
                data.corporate_name = data.rg;

                populate(form, data);
                
                $('#a-first').val(data.first);
                $('#a-cpf').val(data.cpf_cnpj);
                $('#a-corporate').val(data.corporate_name);
                
                $('#inputphones_list').val("");
                
                if(!($("#costumerData").data('bs.modal') || {})._isShown){
                  
                  $('#sac_fantasy_name_input').val(data.first);
                  $('#sac_corporate_name_input').val(data.rg);
                  $('#sac_cpf_cnpj_input').val(data.cpf_cnpj);
  
                  $('#sac_telefone1_input').val(data.telefone)
                  $('#sac_telefone2_input').val(data.telefone_celular)
                  $('#sac_telefone3_input').val(data.telefonedebusca)
                }

                $("#listphones_list option").remove();
                data.phones.forEach(element => {
                  const html = `<option value="${element}">${element}</option>`
                  $("#listphones_list").append(html);
                });
              }
              self.found = 0;
            }
          });
        });
      return
	}
  }
};
</script>
